export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      serviceFunctionName: "ビデオチャット機能",
      videoChatSetting: [
        "device002"
      ]
    }
  }
}